import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, take, throwError } from 'rxjs';
import { environment } from 'oneok/environments/environment';
import { AccessRequest } from '@legacy-models/portal/OnboardRequest';

@Injectable()
export class Onboard {
  private readonly _http: HttpClient = inject(HttpClient);
  private readonly _baseUrl = environment.apiUrlV2;

  createOnboardRequest(req: AccessRequest): Observable<any> {
    return this._http
      .post(this._baseUrl + '/accessrequests/onboard', req, {
        responseType: 'text'
      })
      .pipe(
        catchError(error => throwError(() => error)),
        take(1)
      );
  }

  retrieveOnboardRequest(email: string): Observable<any> {
    return this._http.get(this._baseUrl + '/v1/access/onboardrequest/' + email);
  }
}
